import { useState } from "react";

const useSelectedDate = (initialTimezone = "America/Detroit") => {
  // Get todays date
  const getInitialDate = () => {
    const options = {
      timeZone: initialTimezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    const formattedDate = new Date().toLocaleDateString("en-US", options);
    const [month, day, year] = formattedDate.split("/");
    return `${year}-${month}-${day}`; // YYYY-MM-DD format
  };

  const [selectedDate, setSelectedDate] = useState(getInitialDate);

  return [selectedDate, setSelectedDate];
};

export default useSelectedDate;
